import { createRouter } from '@tanstack/react-router'
import { rootRoute, type RouterContext } from './routes/__root'
import { indexRoute } from './routes/index'
import { activityRoute } from './routes/activity'
import { chatRoute } from './routes/chat'
import { settingsRoute } from './routes/settings'
import { loginRoute } from './routes/login'
import { legacyKanbanRoute } from './routes/_legacy.kanban'
import { approvalsRoute, approvalDetailRoute } from './routes/approvals'
import { cronsRoute } from './routes/crons'

const routeTree = rootRoute.addChildren([
  indexRoute,
  activityRoute,
  chatRoute,
  settingsRoute,
  loginRoute,
  legacyKanbanRoute,
  approvalsRoute,
  approvalDetailRoute,
  cronsRoute,
])

export function createAppRouter(context: RouterContext) {
  return createRouter({
    routeTree,
    context,
    defaultPreload: 'intent',
  })
}

export type AppRouter = ReturnType<typeof createAppRouter>

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter
  }
}
